import customFetch from "./helper"
import { ErrorResponse, SuccessResponse } from "@types"

const API = "/tasks"

type Crosspost = {
  id: string
  blogId: string
  feedUrl: string
  sendNewsletter: boolean
  lastImportedTs: number
}

export async function createCrosspost(
  blogId: string,
  feedUrl: string,
  sendNewsletter: boolean
): Promise<(SuccessResponse & { crosspost: Crosspost }) | ErrorResponse> {
  try {
    const response = await customFetch<
      (SuccessResponse & { crosspost: Crosspost }) | ErrorResponse
    >(`${API}/crosspost`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ blogId, feedUrl, sendNewsletter }),
    })
    if (response.success) {
      return { success: true, crosspost: response.crosspost }
    } else {
      return Promise.reject(new Error(response.msg))
    }
  } catch (e) {
    return Promise.reject(new Error("Unexpected error. Please try again."))
  }
}

export async function updateCrosspost(
  crosspostData: Crosspost
): Promise<SuccessResponse | ErrorResponse> {
  try {
    const { id, ...crosspost } = crosspostData
    const response = await customFetch<
      (SuccessResponse & { crosspost: Crosspost }) | ErrorResponse
    >(`${API}/crosspost/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(crosspost),
    })
    if (response.success) {
      return { success: true }
    } else {
      return Promise.reject(new Error(response.msg))
    }
  } catch (e) {
    return Promise.reject(new Error("Unexpected error. Please try again."))
  }
}

export async function deleteCrosspost(
  crosspostId: string
): Promise<SuccessResponse | ErrorResponse> {
  try {
    const crosspost = await customFetch<SuccessResponse | ErrorResponse>(
      `${API}/crosspost/${crosspostId}`,
      {
        method: "DELETE",
      }
    )
    if (crosspost.success) {
      return { success: true }
    } else {
      return Promise.reject(new Error(crosspost.msg))
    }
  } catch (e) {
    return Promise.reject(new Error("Unexpected error. Please try again."))
  }
}

export async function getCrosspostFromBlogId(blogId: string) {
  try {
    const { success, data } = await customFetch<{
      success: boolean
      data: Crosspost
    }>(`${API}/crosspost/${blogId}`, {
      method: "GET",
    })
    if (success) {
      return data
    }
    return null
  } catch (e) {
    return null
  }
}
